import * as MUI from "@mui/material";

type LabelInfoProps = {
  label: string;
  info: string | number;
};

export const LabelInfo: React.FC<LabelInfoProps> = ({ label, info }) => {
  return (
    <>
      <MUI.Typography fontWeight="bold" variant="body1">
        {label}
      </MUI.Typography>
      <MUI.Typography variant="body1">{info}</MUI.Typography>
    </>
  );
};
